import React from 'react';
import './footer.scss';
import { FiTwitter } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer>
      <a 
        href="https://twitter.com/georgejustin22"
        rel="noopener noreferrer"
        target="_blank"
      >
        <FiTwitter size="25"/>
      </a>
    </footer>
  )
}
export default Footer;